export enum AuthRoutesEnum {
  LOGIN = '/login',
}
